import compact from 'lodash/compact';
import isNil from 'lodash/isNil';

import { isSocialProvider, SocialProvider } from './socialProviders';

interface LinkedAccountLike {
  id: string;
  providerId: string;
}

const LINK_FLOW_ERROR_MESSAGE_IDS: Record<string, string> = {
  email_does_not_match: 'settings.security.linkedAccounts.emailMismatch',
  account_already_linked_to_different_user: 'settings.security.linkedAccounts.alreadyLinkedToAnotherUser',
};

const UNLINK_ERROR_MESSAGE_IDS: Record<string, string> = {
  FAILED_TO_UNLINK_LAST_ACCOUNT: 'settings.security.linkedAccounts.cannotUnlinkLastMethod',
  SESSION_NOT_FRESH: 'settings.security.linkedAccounts.sessionNotFresh',
};

export const getLinkedProviders = (accounts: LinkedAccountLike[]): SocialProvider[] =>
  compact(accounts.map(({ providerId }) => (isSocialProvider(providerId) ? providerId : null)));

export const getProviderAccountIds = (accounts: LinkedAccountLike[], provider: SocialProvider): string[] =>
  accounts.filter(({ providerId }) => providerId === provider).map(({ id }) => id);

export const getLinkFlowErrorMessageId = (error: string | null): string | null => {
  if (isNil(error)) {
    return null;
  }
  return LINK_FLOW_ERROR_MESSAGE_IDS[error] ?? 'settings.security.linkedAccounts.linkFailed';
};

export const getUnlinkErrorMessageId = (code: string | undefined): string =>
  (isNil(code) ? undefined : UNLINK_ERROR_MESSAGE_IDS[code]) ?? 'settings.security.linkedAccounts.unlinkFailed';
